import { render } from "./Greeting.vue?vue&type=template&id=042c40b1&scoped=true"
const script = {}

import "./Greeting.vue?vue&type=style&index=0&id=042c40b1&lang=scss&scoped=true"

import exportComponent from "C:\\bonch\\okimi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-042c40b1"]])

export default __exports__